import { defineStore } from 'pinia';

import { User, UserInput } from '@/entities/User';

export const useAuthStore = defineStore('authStore', {
  state() {
    return {
      user: null as User | null,
    };
  },
  actions: {
    setUser(user: UserInput) {
      this.user = new User(user);
      localStorage.setItem('user', JSON.stringify(user));
    },
    init() {
      const user: string | null = localStorage.getItem('user');
      if (user) {
        const userObject = JSON.parse(user);
        this.setUser(userObject);
      }
    },
  },
});
